// Equipment type configuration for all 8 types
// Each config describes: API slug, association alias, display label, field definitions, and table columns

export const EQUIPMENT_CONFIG = {
  transformers: {
    slug: "transformers",
    alias: "substation_transformers",
    label: "Трансформатор",
    maintTable: "sub_transformer_maintenance",
    fields: [
      { key: "name", label: "Номи", type: "text", required: true },
      { key: "transformer_type", label: "Тури", type: "text" },
      { key: "rated_power_mva", label: "Қувват (МВА)", type: "text" },
      { key: "voltage", label: "Кучланиш (кВ)", type: "text" },
      { key: "allowed_nominal_current_a", label: "Рухсат этилган номинал токи (A)", type: "number", min: "0", step: "any", inputMode: "decimal", group: "Ток юкламаси" },
      { key: "max_load_current_a", label: "Максимал юклама токи, факт бўйича (A)", type: "number", min: "0", step: "any", inputMode: "decimal", group: "Ток юкламаси" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "inventory_number", label: "Инвентар рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["name", "transformer_type", "rated_power_mva", "voltage", "serial_number"],
    columnLabels: ["Номи", "Тури", "Қувват", "Кучланиш", "Серия №"],
  },
  breakers: {
    slug: "breakers",
    alias: "substation_breakers",
    label: "Ўчиргич",
    maintTable: "sub_breaker_maintenance",
    fields: [
      { key: "name", label: "Номи", type: "text", required: true },
      { key: "breaker_type", label: "Тури", type: "text" },
      { key: "voltage", label: "Кучланиш (кВ)", type: "text" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["name", "breaker_type", "voltage", "serial_number"],
    columnLabels: ["Номи", "Тури", "Кучланиш", "Серия №"],
  },
  disconnectors: {
    slug: "disconnectors",
    alias: "substation_disconnectors",
    label: "Ажратгич",
    maintTable: "sub_disconnector_maintenance",
    fields: [
      { key: "name", label: "Номи", type: "text", required: true },
      { key: "disconnector_type", label: "Тури", type: "text" },
      { key: "voltage", label: "Кучланиш (кВ)", type: "text" },
      { key: "poles_count", label: "Қутблар сони", type: "text" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["name", "disconnector_type", "voltage", "poles_count", "serial_number"],
    columnLabels: ["Номи", "Тури", "Кучланиш", "Қутблар", "Серия №"],
  },
  reactors: {
    slug: "reactors",
    alias: "substation_reactors",
    label: "Реактор",
    maintTable: "sub_reactor_maintenance",
    fields: [
      { key: "name", label: "Номи", type: "text", required: true },
      { key: "reactor_type", label: "Тури", type: "text" },
      { key: "voltage", label: "Кучланиш (кВ)", type: "text" },
      { key: "nominal_current_a", label: "Ном. ток (А)", type: "text" },
      { key: "inductive_resistance_ohm", label: "Индук. қаршилик (Ом)", type: "text" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["name", "reactor_type", "voltage", "nominal_current_a", "serial_number"],
    columnLabels: ["Номи", "Тури", "Кучланиш", "Ток (А)", "Серия №"],
  },
  arresters: {
    slug: "arresters",
    alias: "substation_arresters",
    label: "Разрядник",
    maintTable: "sub_arrester_maintenance",
    fields: [
      { key: "name", label: "Номи", type: "text", required: true },
      { key: "arrester_type", label: "Тури", type: "text" },
      { key: "voltage_class_kv", label: "Кучланиш синфи (кВ)", type: "text" },
      { key: "max_permitted_voltage_kv", label: "Макс. кучланиш (кВ)", type: "text" },
      { key: "nominal_discharge_current_ka", label: "Ном. разряд токи (кА)", type: "text" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      { key: "height_m", label: "Баландлик (м)", type: "text" },
      { key: "weight_kg", label: "Оғирлик (кг)", type: "text" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["name", "arrester_type", "voltage_class_kv", "serial_number"],
    columnLabels: ["Номи", "Тури", "Кучланиш синфи", "Серия №"],
  },
  "current-transformers": {
    slug: "current-transformers",
    alias: "substation_current_transformers",
    label: "Ток трансформатори",
    maintTable: "sub_current_transformer_maintenance",
    fields: [
      { key: "name", label: "Номи", type: "text", required: true },
      { key: "ct_type", label: "Тури", type: "text" },
      { key: "voltage", label: "Кучланиш (кВ)", type: "text" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["name", "ct_type", "voltage", "serial_number"],
    columnLabels: ["Номи", "Тури", "Кучланиш", "Серия №"],
  },
  "voltage-transformers": {
    slug: "voltage-transformers",
    alias: "substation_voltage_transformers",
    label: "Кучланиш трансформатори",
    maintTable: "sub_voltage_transformer_maintenance",
    fields: [
      { key: "name", label: "Номи", type: "text", required: true },
      { key: "vt_type", label: "Тури", type: "text" },
      { key: "voltage", label: "Кучланиш (кВ)", type: "text" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["name", "vt_type", "voltage", "serial_number"],
    columnLabels: ["Номи", "Тури", "Кучланиш", "Серия №"],
  },
  batteries: {
    slug: "batteries",
    alias: "substation_batteries",
    label: "Аккумулятор",
    maintTable: "sub_battery_maintenance",
    fields: [
      { key: "battery_type", label: "Тури", type: "text" },
      { key: "serial_number", label: "Серия рақами", type: "text" },
      { key: "manufacture_year", label: "Ишлаб чиқ. йили", type: "date" },
      { key: "start_year", label: "Ишга туш. йили", type: "date" },
      { key: "cells_count", label: "Элементлар сони", type: "text" },
      { key: "capacity_ah", label: "Сиғим (Аҳ)", type: "text" },
      { key: "element_mass_kg", label: "Элемент массаси (кг)", type: "text" },
      // details скрыт — нужен WYSIWYG редактор
    ],
    columns: ["battery_type", "serial_number", "capacity_ah", "cells_count"],
    columnLabels: ["Тури", "Серия №", "Сиғим (Аҳ)", "Элементлар"],
  },
};

export const EQUIPMENT_TABS = Object.entries(EQUIPMENT_CONFIG).map(([key, cfg]) => ({
  key,
  label: cfg.label,
}));

export const MAINTENANCE_FIELDS = [
  { key: "topic", label: "Мавзу", type: "text", required: true },
  { key: "event_date", label: "Сана", type: "date", required: true },
  { key: "comment", label: "Изоҳ", type: "textarea" },
  { key: "result", label: "Натижа", type: "textarea" },
];
